const {__} = wp.i18n;

const { TextControl, Panel, PanelBody, PanelRow, Button, Grid, BoxControl, Modal, FormToggle } = wp.components;
const { useState, useEffect }  =  wp.element;
const { withDispatch } = wp.data;
const { extensionCartUpdate } = wc.blocksCheckout;
const { getSetting } = wc.wcSettings;

export const WooFoodOrderTypeBlockFront = ( {attributes, className} ) => {
			//const [tipAmount, setTipAmount] = useState();

				 const { woofood_order_types: woofood_order_types } = getSetting( 'woofood-checkout-blocks_data' );

			     //const [checkedOrderType, setCheckedOrderType] = useState('delivery');
				const [checkedOrderType, setCheckedOrderType] = "delivery"

	



		return (
			<div className={className}>
		
			
			<div className="woofood_order_type" style={{
			background: attributes.BodyBackgroundColor || undefined
		}}>


		{Object.entries(woofood_order_types).map(function([key, value], i){
			return (
				<label key={i} className="wf_field_wrapper  wf_order_type_radio_50" style={{color:attributes.CheckboxLabelColor }}>
				{value}
				<input type="radio" name="woofood_order_type" id="woofood_order_type" value={key} onClick={()=>setCheckedOrderType(key)}/>
				<span className="checkmark" style={checkedOrderType == key ? {backgroundColor:attributes.CheckboxBackgroundColor} : {}} ></span>
				</label>


			


				);

		})}

			</div>
			</div>
			);
		
		

		}

